

// global variables

// if (typeof storefrontAccessToken === "undefined") {
  var storefrontAccessTokenFilt = "ad652a74eb9b4c8cc3d7c521feaa9e06"; 
  
// } 

if (typeof bodyClasses === "undefined") {
  var bodyClasses = document.body.className;
  // console.log("Declared bodyClasses:", bodyClasses);
}


// if template Product
if (bodyClasses.includes('product-page-loaded')) {  

if (typeof relatedProduct === 'function') {
  relatedProduct();
}

function slickSlider() {
  $(".relatedProduct").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

} // end if condition of template


// if template Index
if (bodyClasses.includes('template-index')) {  
//    Home Slider    //
if ($(".laberSlidershow .grid-slider").length) {
    $(".laberSlidershow .grid-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
} else {
    console.error("Element .laberSlidershow .grid-slider not found!");
}


//    Related Product Slider PDPage


//        Search filter       //

var productDetails = [];
var search_Attr = "";
var new_array = [];

var product_tag = "only-water-filter"; // Default selection
var search_tag = "Water Filters";

// Function to handle button clicks
$(".filter-btn").click(function () {
  // console.log("clicked filter button")
  $('.loader_filter').css('display','block')
  // $(".suggestion-list").addClass("hidden-important");
  var buttonId = $(this).attr("id");
  // console.log("buttonId",buttonId)

  if (buttonId === "defaultOpen") {
    $(".water-ul").show();
    product_tag = "only-water-filter";
    search_tag = "Water Filters";
    $(".search-product").css("display", "block");
    $(".searcfilter").val("");
    // $('.ice-maker-def-prod').empty();
   
  } else if (buttonId === "remoteCon") {
   
    $(".remote-ul").show();
    // $('.ice-maker-def-prod').empty();
    // console.log("airfilter>>>>>>>")
    product_tag = "Remote Control";
    search_tag = "Remote Control";
    $(".search-product").css("display", "block");
    $(".searcfilter").val("");
  } else if (buttonId === "icemakerbtn") {
    // console.log("buttonId else condition",buttonId)
    product_tag = "only-ice-maker";
    search_tag = "Ice Maker";
    $(".ice-ul").show();
    $(".ice-maker-def-prod").empty();
    $(".search-product").css("display", "block");
    $(".searcfilter").val("");
  }

  // console.log("buttonId>>>",buttonId)
  // $('.ice-maker-def-prod').empty()
  getApiProData(product_tag)
  
   // getTagProDetails(); 
});

// Trigger default selection
$("#defaultOpen").click();


if ($(".suggestion-list").children().length > 0) {
  $(".search-product").css("display", "none");
} else {
  $(".search-product").css("display", "block");
}







// $(document).on("input", "#search, #Airsearch, #Icesearch", function () {
//   // console.log("display input>>>", $(this).val());

//   var valSear = $.trim($(this).val());
//   console.log("valSear", valSear);

//   if ($.trim($(this).val()) == "") {
//     // console.log("blank")
//     $("section.search_with_bg .brand-item").removeClass("zoomed");

//     $(".suggestion-list").css("display", "block");
//     $(".suggestion-list").addClass("hidden-important");
//     // $('.suggestion-list').addClass('hidden');

//     $(".water-filter-def-prod").show();
//     $(".remote-controler-def-prod").show();
//     $(".ice-maker-def-prod").show();
//     $(".search-product").css("display", "block");
//     $(".search-product").addClass("ActiveBox");
//   }
//   if (valSear) {
//     console.log("Not Blank")
//     $(".suggestion-list").removeClass("hidden");
//     $(".suggestion-list").removeClass("hidden-important");
//     $(".suggestion-list").css("display", "block");
//     $(".search-product").css("display", "none");
//     $(".search-product").removeClass("ActiveBox");
//     $(".water-filter-def-prod").hide();
//     $(".remote-controler-def-prod").hide();
//     $(".ice-maker-def-prod").hide();
//   }
// });

// end Code 

$(".js_btn_search").click(function () {
  console.log("test5");
   let searchTerm = "";

  // 1️⃣ Check for visible text input
  const visibleInput = $(".searcfilter:visible");
  if (visibleInput.length) {
    searchTerm = visibleInput.val().trim();
  }

  // 2️⃣ If no text input, check for visible dropdown
  if (!searchTerm) {
    const visibleDropdown = $("select:visible");
    if (visibleDropdown.length) {
      searchTerm = visibleDropdown.val()?.trim() || "";
    }
  }
  console.log("searchTerm", searchTerm)

  // 3️⃣ Fire GTM event even if searchTerm is empty
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      // Shopify.analytics.publish('search_bottom', {
      //     customData: {
      //         search_term: searchTerm || ''
      //       }
      // });
      // console.log("✅ Shopify analytics 'search_bottom' event published");
    } else {
      // console.warn("⚠️ Shopify.analytics.publish not available");
    }
  // console.log("✅ GTM Event Fired: search_bottom", searchTerm);
  // e.preventDefault(); 
  // e.stopPropagation();
  console.log("js_btn_search")
  $('.loader_filter').show();

  var productActiveText = $('.filter-btn.active').attr('filtersubcate');
  // console.log('Active Button Text:', productActiveText);

  
  var inputValue = '';
   var selectedBrand = '';
  var water_filter =  $('#London').find('.searcfilter').val();
  var ice_maker = $('#icemaker').find('.searcfilter').val();
  var remote_controls = $('#Paris').find('.searcfilter').val();

   if (water_filter) {
    inputValue = water_filter;
  } else if (ice_maker) {
    inputValue = ice_maker;
  } else if (remote_controls) {
    inputValue = remote_controls;
  } else {
    // console.log("No search input provided.");
     $('.suggestion-list').removeClass('hidden-important');
     $('.loader_filter').hide();
     $('.mesaage_forData').hide();
  }
  // console.log("inputValue",inputValue.length)

  var ice_collectionsValue = $("#icemaker").find('.select_brandFilter option:selected').val();
  // console.log("ice_collectionsValue",ice_collectionsValue)
  var water_collectionsValue = $("#London").find('.select_brandFilter option:selected').val();
  // console.log("water_collectionsValue",water_collectionsValue)
  var remote_collectionsValue = $("#Paris").find('.select_brandFilter option:selected').val();
  // console.log("remote_collectionsValue",remote_collectionsValue)




  function isValid(value) {
    return value && value !== 'Select';
  }


  if (ice_collectionsValue != 'Select') {
        selectedBrand = ice_collectionsValue;
      } else if (water_collectionsValue != 'Select') {
        selectedBrand = water_collectionsValue;
      } else if (remote_collectionsValue != 'Select') {
        selectedBrand = remote_collectionsValue;
      } else {
        // console.log("blank selectedBrand")
        selectedBrand = '';
        // console.log("No valid collectionsvalue selected.");
      }
      
        // Push to dataLayer for tracking
       if (inputValue || selectedBrand) {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('search_bottom', {
            customData: {
              search_term: inputValue || '',
              search_brand: selectedBrand || '',
              page_path: window.location.pathname || '',
              page_location: window.location.href || '',
              page_title: document.title || ''
            }
          });
          // console.log("✅ Shopify analytics 'search_bottom' event published");
        } else {
          // console.warn("⚠️ Shopify.analytics.publish not available");
        }
      }
              


    if (inputValue && selectedBrand && productActiveText ) {
    getApiProData(productActiveText, inputValue, selectedBrand);
  } else if (inputValue && productActiveText) {
    getApiProData(productActiveText, inputValue, '');
  } else if (selectedBrand && productActiveText) {
    getApiProData(productActiveText, '', selectedBrand);
  }else {
    // console.log("No input or selected brand.");
  }

  
});  

async function getApiProData(product_tag,searchval,brandname) {
  // console.log("product_tag>>",product_tag,"searchval>>",searchval,"brandname>>",brandname)
  
  var query = '';
  
  if(product_tag && searchval && brandname ){
    if(product_tag == 'only-water-filter' || product_tag == 'only-ice-maker') {
      query += "vendor:'"+brandname+"' AND tag:'"+product_tag+"' AND title:*"+searchval+"* AND product_type:Part "; 
    }else{
      query += "vendor:'"+brandname+"' AND tag:'subcate:"+product_tag+"' AND title:*"+searchval+"* AND product_type:Part "; 
    }
    
  }else if(searchval && product_tag){
     if(product_tag == 'only-water-filter' || product_tag == 'only-ice-maker') {
       query += "tag:'"+product_tag+"' AND title:*"+searchval+"* AND product_type:Part"; 
     }else{
       query += "tag:'subcate:"+product_tag+"' AND title:*"+searchval+"* AND product_type:Part"; 
     }
     
  }else if(brandname  && product_tag ){
    if(product_tag == 'only-water-filter' || product_tag == 'only-ice-maker') {
      query += "vendor:'"+brandname+"' AND tag:'"+product_tag+"' AND product_type:Part"; 
    }else{
      // query += "vendor:'"+brandname+"'";
    query += "vendor:'"+brandname+"' AND tag:'subcate:"+product_tag+"' AND product_type:Part"; 
    }
    
  }else if(product_tag != '' && !brandname && !searchval ){
    console.log("product_tag>>><<<<<",product_tag)
    if(product_tag == 'only-water-filter' || product_tag == 'only-ice-maker') {
      // console.log("if condition for water and ice")
      query += "tag:'"+product_tag+"' AND product_type:Part"; 
    }else{
      query += "tag:'subcate:"+product_tag+"' AND tag:'showfirst' AND product_type:Part"; 
    }
    
  }
  else{
    // console.log("else else")
   // query +=   "title:'"+searchval+"'";
  }

  console.log("query",query)
  // console.log("product_tag inside the function api ", product_tag)
  // console.log("search_tag inside the function api ", search_tag);

  const response = fetch(
    "https://grp-site.myshopify.com/api/2023-04/graphql.json",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storefrontAccessTokenFilt,
      },

      body: JSON.stringify({
        query: `{
                  products(
                    first: 10
                    query: "${query}"
                  ) {
                    nodes {
                            title
                            tags
                            productType
                            id
                            vendor
                            handle
                            variants(first: 10) {
                              nodes {
                                id
                                price {
                                  amount
                                }
                                sku
                              }
                            }  
                            images(first: 10) {
                              nodes {
                                originalSrc
                              }
                            }
                          }
                  }
                }
                                            `,
      }),
    }
  )
    // console.log("response",response)

    // const result = await response.json();
    .then((response) => response.json()) // Resolving the JSON promise
    .then((data) => {
      console.log("response444>>>", data);
      if (data.data.products.nodes.length === 0) 
      {
      // Perform an action when nodes are empty
      // console.log("No products available.");
       $("#suggestion-list").html("");
        
         if($('.suggestion-list').hasClass('hidden-important')) {
           // console.log("removed")
           $('.mesaage_forData').css('display','none !important');
           $('.suggestion-list').removeClass('hidden-important')
           $('.loader_filter').css('display','none')
        }else{
           // console.log("Not removed")
           $('.mesaage_forData').css('display','block')
           $('.suggestion-list').addClass('hidden-important')
           $('.loader_filter').css('display','none')
        }
      }else{
        $('.suggestion-list').removeClass('hidden-important')
        // console.log("else display")
        $('.mesaage_forData').css('display','none');
      const product_search = data?.data?.products;
        // console.log("product_search",product_search)
      var Brand_json = [
        { lineCode: "ZEN", Brand: "1LG" },
        { lineCode: "BRT", Brand: "Bertazzoni" },
        { lineCode: "SMG", Brand: "Samsung" },
        { lineCode: "AAC", Brand: "ARCTIC AIR C" },
        { lineCode: "ABT", Brand: "ABBOTT" },
        { lineCode: "ABU", Brand: "Abu Garcia" },
        { lineCode: "ACE", Brand: "AIRTOUCH" },
        { lineCode: "ACF", Brand: "ALL FILTERS" },
        { lineCode: "ACP", Brand: "ACP" },
        { lineCode: "ACR", Brand: "ACER" },
        { lineCode: "ACU", Brand: "ACCU SHARP" },
        { lineCode: "ACX", Brand: "ACER REFURB" },
        { lineCode: "AEL", Brand: "AERIS ENVIRONMENTAL" },
        { lineCode: "AFF", Brand: "AFFINITY" },
        { lineCode: "AGA", Brand: "AGA MARVEL" },
        { lineCode: "AGR", Brand: "AGRI-FAB" },
        { lineCode: "AIP", Brand: "AIPHONE" },
        { lineCode: "AIR", Brand: "AIRWELL FEDDERS" },
        { lineCode: "AIW", Brand: "AIWA" },
        { lineCode: "AKI", Brand: "AKAI" },
        { lineCode: "ALH", Brand: "ALPHA" },
        { lineCode: "ALP", Brand: "ALPINE" },
        { lineCode: "ALR", Brand: "ALARIS" },
        { lineCode: "AMA", Brand: "AMANA COMMERICAL" },
        { lineCode: "AME", Brand: "AMERICAN LAWN" },
        { lineCode: "AMF", Brand: "AMERICAN METAL FILTE" },
        { lineCode: "AMS", Brand: "AMERICAN STANDARD" },
        { lineCode: "AMT", Brand: "AIRMASTER" },
        { lineCode: "AND", Brand: "ANDIS" },
        { lineCode: "ANR", Brand: "AEONAIR" },
        { lineCode: "AOC", Brand: "AOC/EPI" },
        { lineCode: "APA", Brand: "APPLE REPLACEMENT" },
        { lineCode: "APL", Brand: "APL" },
        { lineCode: "APX", Brand: "APEX" },
        { lineCode: "ARC", Brand: "ARCLYTE TECHNOLOGIES" },
        { lineCode: "ARD", Brand: "ARDISAM" },
        { lineCode: "ARI", Brand: "Ariens Company" },
        { lineCode: "ARK", Brand: "AIR KING" },
        { lineCode: "ARM", Brand: "ARMSTRONG" },
        { lineCode: "ARR", Brand: "ARRCO LLC" },
        { lineCode: "ASK", Brand: "ASKO" },
        { lineCode: "ASU", Brand: "Asus" },
        { lineCode: "ASR", Brand: "ASUS REFURB" },
        { lineCode: "AST", Brand: "ASTI" },
        { lineCode: "ATR", Brand: "ASTRA" },
        { lineCode: "AVA", Brand: "AVANTI PRODUCTS" },
        { lineCode: "AVT", Brand: "AVENT" },
        { lineCode: "BAC", Brand: "BACKER EHP" },
        { lineCode: "BAD", Brand: "BAD PART NUMBER" },
        { lineCode: "BAR", Brand: "B-AIR" },
        { lineCode: "BAT", Brand: "HIGH CAPACITY" },
        { lineCode: "BAX", Brand: "BAXTER" },
        { lineCode: "BBD", Brand: "BLUEBIRD" },
        { lineCode: "BBN", Brand: "BRAUN (DELONGHI)" },
        { lineCode: "BCH", Brand: "BOSCH" },
        { lineCode: "BCH", Brand: "Bosch Commerical" },
        { lineCode: "BDR", Brand: "BLUEDRI" },
        { lineCode: "BEC", Brand: "BECKMAN INDUSTRIAL" },
        { lineCode: "BEL", Brand: "0" },
        { lineCode: "BEN", Brand: "BENQ USA" },
        { lineCode: "BER", Brand: "BLUE EMBER" },
        { lineCode: "BGR", Brand: "B GREEN INNOVATIONS" },
        { lineCode: "BGT", Brand: "BLODGETT" },
        { lineCode: "BIE", Brand: "BIESEMEYER" },
        { lineCode: "BIO", Brand: "BIONAIRE" },
        { lineCode: "BIS", Brand: "BISSELL" },
        { lineCode: "BKS", Brand: "BROOKSTONE" },
        { lineCode: "BLA", Brand: "BLACK & DECKER" },
        { lineCode: "BLK", Brand: "BROIL KING" },
        { lineCode: "BLM", Brand: "BLOMBERG" },
        { lineCode: "BLO", Brand: "" },
        { lineCode: "BLR", Brand: "BRITELITE REFURBISH" },
        { lineCode: "BLT", Brand: "BRILLIANT SCENTS" },
        { lineCode: "BLU", Brand: "BLU PRODUCTS" },
        { lineCode: "BMR", Brand: "BROILMASTER" },
        { lineCode: "BOL", Brand: "BOLENS" },
        { lineCode: "BOS", Brand: "BOSE" },
        { lineCode: "BOX", Brand: "BOXES" },
        { lineCode: "BQN", Brand: "BINATONE ELECTRONICS" },
        { lineCode: "BRA", Brand: "BRAUN" },
        { lineCode: "BRD", Brand: "BARRANCA DIAMOND" },
        { lineCode: "BRE", Brand: "BREVILLE" },
        { lineCode: "BRI", Brand: "BRISTOL" },
        { lineCode: "BRK", Brand: "BROKSONIC" },
        { lineCode: "BRL", Brand: "BRILLIANT INK & TONE" },
        { lineCode: "BRM", Brand: "BROIL-MATE" },
        { lineCode: "BRN", Brand: "BROAN" },
        { lineCode: "BRO", Brand: "BROTHER" },
        { lineCode: "BRR", Brand: "BROTHER REFURB" },
        { lineCode: "BRS", Brand: "BROWN STOVE" },
        { lineCode: "BRT", Brand: "BERTAZZONI" },
        { lineCode: "BRY", Brand: "BARRY RESTORE IT ALL" },
        { lineCode: "BSA", Brand: "BOSTON ACOUSTICS" },
        { lineCode: "BSG", Brand: "BRIGGS POWER" },
        { lineCode: "BSH", Brand: "BOSCH TOOLS" },
        { lineCode: "BSM", Brand: "MURRAY" },
        { lineCode: "BSP", Brand: "BRIGGS STRATTON" },
        { lineCode: "BTH", Brand: "BOSTITCH" },
        { lineCode: "BTI", Brand: "BATTERY TECHNOLOGY" },
        { lineCode: "BUN", Brand: "BUNN" },
        { lineCode: "BWL", Brand: "BOWERS WILKINS" },
        { lineCode: "CA1", Brand: "CANON CONSUMER" },
        { lineCode: "CA2", Brand: "CANON CAMERA" },
        { lineCode: "CAF", Brand: "CAFE GE APPLIANCE" },
        { lineCode: "CAL", Brand: "CALPHALON" },
        { lineCode: "CAN", Brand: "CANON" },
        { lineCode: "CAR", Brand: "CARRIER" },
        { lineCode: "CAS", Brand: "CASIO" },
        { lineCode: "CAX", Brand: "CANON REFURB" },
        { lineCode: "CBC", Brand: "CRARY BEAR CAT" },
        { lineCode: "CBL", Brand: "CHAR-BROIL" },
        { lineCode: "CBY", Brand: "COBY (REFURBISH)" },
        { lineCode: "CCF", Brand: "CAMP CHEF" },
        { lineCode: "CCS", Brand: "CIRCUIT CITY SERVICE" },
        { lineCode: "CEL", Brand: "CELL PHONE" },
        { lineCode: "CGI", Brand: "GREEN CHOICE" },
        { lineCode: "CHA", Brand: "CHAMPION" },
        { lineCode: "CHD", Brand: "CAMPBELL HAUSFELD" },
        { lineCode: "CHE", Brand: "CHEMTRONICS" },
        { lineCode: "CHI", Brand: "CHIPQUIK" },
        { lineCode: "CHL", Brand: "CHAMBERLAIN" },
        { lineCode: "CKP", Brand: "CYBERKITS" },
        { lineCode: "CLA", Brand: "Classen" },
        { lineCode: "CLC", Brand: "CLECO" },
        { lineCode: "CLE", Brand: "CLEVELAND" },
        { lineCode: "CLO", Brand: "CIELO" },
        { lineCode: "CLP", Brand: "CALSPA" },
        { lineCode: "CLR", Brand: "CLARION" },
        { lineCode: "COL", Brand: "COLEMAN" },
        { lineCode: "COM", Brand: "COMPUTER" },
        { lineCode: "CON", Brand: "CONTINENTAL FAN" },
        { lineCode: "COO", Brand: "COOPER" },
        { lineCode: "CPC", Brand: "CHICAGO PNEUMATIC" },
        { lineCode: "CPN", Brand: "CHAPIN" },
        { lineCode: "CPQ", Brand: "COMPAQ" },
        { lineCode: "CPX", Brand: "COMPAQ REFURB" },
        { lineCode: "CRA", Brand: "CRAFTSMAN" },
        { lineCode: "CRC", Brand: "CRES COR" },
        { lineCode: "CRO", Brand: "CROWN ELECTRONICS" },
        { lineCode: "CRP", Brand: "CROCK POT" },
        { lineCode: "CRS", Brand: "CROSLEY" },
        { lineCode: "CUB", Brand: "Cub Cadet" },
        { lineCode: "CUI", Brand: "CUISINART" },
        { lineCode: "CUR", Brand: "CURLIN" },
        { lineCode: "CYB", Brand: "CYBEX" },
        { lineCode: "DAC", Brand: "DACOR" },
        { lineCode: "DAE", Brand: "Kenmore" },
        { lineCode: "DAM", Brand: "DAMAGED PANELS" },
        { lineCode: "DBY", Brand: "DANBY" },
        { lineCode: "DEF", Brand: "DEFLECT-0" },
        { lineCode: "DEG", Brand: "DELONGHI REPLACEMENT" },
        { lineCode: "DEI", Brand: "DELONGHI" },
        { lineCode: "DEL", Brand: "DELL" },
        { lineCode: "DEN", Brand: "DENON" },
        { lineCode: "DER", Brand: "DELL REFURB" },
        { lineCode: "DEV", Brand: "DEVILBISS" },
        { lineCode: "DEW", Brand: "DEWALT" },
        { lineCode: "DFD", Brand: "DELFIELD" },
        { lineCode: "DFT", Brand: "DEFINITIVE TECH" },
        { lineCode: "DIG", Brand: "DIGITENNA" },
        { lineCode: "DIR", Brand: "DIRT DEVIL" },
        { lineCode: "DIV", Brand: "DIVERSITECH INC" },
        { lineCode: "DML", Brand: "DREMEL" },
        { lineCode: "DNG", Brand: "DNGO INTERNATIONAL" },
        { lineCode: "DOR", Brand: "DORMONT MANUFACTURIN" },
        { lineCode: "DOT", Brand: "DOTCO" },
        { lineCode: "DRA", Brand: "D&R ASSOCIATES INC." },
        { lineCode: "DRE", Brand: "DR POWER EQUIPMENT" },
        { lineCode: "DRG", Brand: "HEAT TOOLS" },
        { lineCode: "DSS", Brand: "DSS" },
        { lineCode: "DTF", Brand: "DELTA FAUCET" },
        { lineCode: "DTL", Brand: "DELTA" },
        { lineCode: "DTP", Brand: "GREEN CHOICE" },
        { lineCode: "DUN", Brand: "DUNDAS JAFINE INC" },
        { lineCode: "DUR", Brand: "DURACELL U.S.A." },
        { lineCode: "DUS", Brand: "DUSTLESS" },
        { lineCode: "DXR", Brand: "DEX REFURBISHED" },
        { lineCode: "DYB", Brand: "DYNABRADE" },
        { lineCode: "DYS", Brand: "DYSON" },
        { lineCode: "ECH", Brand: "ECHO" },
        { lineCode: "ECL", Brand: "ECLIPSE" },
        { lineCode: "ECO", Brand: "FILTERS" },
        { lineCode: "EDI", Brand: "EDIC" },
        { lineCode: "EGO", Brand: "EGO" },
        { lineCode: "EGR", Brand: "GREEN CHOICE" },
        { lineCode: "ELE", Brand: "ELENCO ELECTRONICS" },
        { lineCode: "ELI", Brand: "ELICA" },
        { lineCode: "ELR", Brand: "ELECTRONIC RESOURCES" },
        { lineCode: "ELS", Brand: "GENERIC" },
        { lineCode: "ELX", Brand: "ELECTROLUX PRO" },
        { lineCode: "EMA", Brand: "E-MACHINE" },
        { lineCode: "EME", Brand: "EMERSON" },
        { lineCode: "EMP", Brand: "EMPIRE VIDEO" },
        { lineCode: "EMR", Brand: "EMACHINES REFURB" },
        { lineCode: "ENR", Brand: "ENVISION REFURBISHED" },
        { lineCode: "ENV", Brand: "ENVISION" },
        { lineCode: "EPD", Brand: "ENCOMPASS PARTS" },
        { lineCode: "EPR", Brand: "EPSON REFURB" },
        { lineCode: "EPS", Brand: "EPSON" },
        { lineCode: "ERK", Brand: "EUREKA" },
        { lineCode: "ERP", Brand: "GENERIC REPLACEMENT" },
        { lineCode: "ESC", Brand: "ESCORT" },
        { lineCode: "ESI", Brand: "TILE" },
        { lineCode: "ESP", Brand: "ESPRESSO ACCESSORIES" },
        { lineCode: "ESS", Brand: "ENCOMPASS SERVICE" },
        { lineCode: "EVE", Brand: "EVEREADY BATTERY CO." },
        { lineCode: "EXM", Brand: "EXMARK" },
        { lineCode: "EZF", Brand: "EZ-FLO" },
        { lineCode: "FAM", Brand: "FAMOUS ENTREPRISES" },
        { lineCode: "FAN", Brand: "FANTOM" },
        { lineCode: "FAP", Brand: "FISHER & PAYKEL" },
        { lineCode: "FAS", Brand: "FASCO" },
        { lineCode: "FBT", Brand: "REPLACEMENT FBT" },
        { lineCode: "FEI", Brand: "FEIN" },
        { lineCode: "FIE", Brand: "FIESTA" },
        { lineCode: "FJT", Brand: "FUJITSU" },
        { lineCode: "FLE", Brand: "FLEX" },
        { lineCode: "FLO", Brand: "FLOTEC" },
        { lineCode: "FLU", Brand: "FLUKE" },
        { lineCode: "FMN", Brand: "Freemotion" },
        { lineCode: "FNA", Brand: "SIMPSON DELCO" },
        { lineCode: "FOX", Brand: "FOXCONN" },
        { lineCode: "FPL", Brand: "FRONT PROJECTOR LAMP" },
        { lineCode: "FRE", Brand: "FREUDENBERG FILTRATI" },
        { lineCode: "FRI", Brand: "ELECTROLUX" },
        { lineCode: "FRY", Brand: "FRYMASTER" },
        { lineCode: "FUN", Brand: "FUNAI" },
        { lineCode: "FXA", Brand: "Fuji-Xerox Artermark" },
        { lineCode: "GAL", Brand: "GALPA EXPORT" },
        { lineCode: "GAM", Brand: "GAMING PARTS" },
        { lineCode: "GAR", Brand: "GARMIN" },
        { lineCode: "GAT", Brand: "GATEWAY" },
        { lineCode: "GCE", Brand: "GC-THORSEN" },
        { lineCode: "GCP", Brand: "GREEN CHOICE" },
        { lineCode: "GDG", Brand: "GOLDS GYM" },
        { lineCode: "GEA", Brand: "GE APPLIANCE PRODUCT" },
        { lineCode: "GEM", Brand: "HVAC PARTS" },
        { lineCode: "GEN", Brand: "GENERAC DELCO" },
        { lineCode: "GGL", Brand: "GOOGLE" },
        { lineCode: "GIC", Brand: "GET IT CLEAN" },
        { lineCode: "GIL", Brand: "GILLETTE" },
        { lineCode: "GLN", Brand: "GARLAND" },
        { lineCode: "GLT", Brand: "PHILIP PERSONAL CARE" },
        { lineCode: "GNE", Brand: "GENIE" },
        { lineCode: "GOL", Brand: "GOLIATH" },
        { lineCode: "GOO", Brand: "GOODMAN" },
        { lineCode: "GOP", Brand: "GO PLUS LIGHTING" },
        { lineCode: "GOV", Brand: "GO VIDEO" },
        { lineCode: "GPR", Brand: "GRIP-RITE" },
        { lineCode: "GPS", Brand: "GPS BATTERIES" },
        { lineCode: "GPX", Brand: "GPX REMOTES" },
        { lineCode: "GRA", Brand: "GRACO" },
        { lineCode: "GRI", Brand: "GRINDMASTER" },
        { lineCode: "GRN", Brand: "GREENWORKS" },
        { lineCode: "GRO", Brand: "GROEN" },
        { lineCode: "GSA", Brand: "GE SMALL APPLIANCE" },
        { lineCode: "GTW", Brand: "GATEWAY REFURB" },
        { lineCode: "GUA", Brand: "GUARDSMAN" },
        { lineCode: "HAB", Brand: "HABEGGER CORP" },
        { lineCode: "HAD", Brand: "Honda Marine" },
        { lineCode: "HAI", Brand: "HAIER" },
        { lineCode: "HAK", Brand: "AMERICAN HAKKO" },
        { lineCode: "HAM", Brand: "HAMILTON BEACH" },
        { lineCode: "HAN", Brand: "HANNSPREE" },
        { lineCode: "HAR", Brand: "HARMON KARDON" },
        { lineCode: "HAT", Brand: "HATCO" },
        { lineCode: "HAY", Brand: "HAYWARD" },
        { lineCode: "HCT", Brand: "HCT" },
        { lineCode: "HCU", Brand: "HYUNDAI CORPORATION" },
        { lineCode: "HEA", Brand: "HEATSTAR" },
        { lineCode: "HEM", Brand: "HP/CANON" },
        { lineCode: "HEW", Brand: "HP" },
        { lineCode: "HHG", Brand: "HEAT HOG" },
        { lineCode: "HIS", Brand: "HISENSE/ELEMENT" },
        { lineCode: "HIT", Brand: "HITACHI" },
        { lineCode: "HKC", Brand: "HKC DIGITAL" },
        { lineCode: "HKY", Brand: "HUSKY" },
        { lineCode: "HNP", Brand: "HENNY PENNY" },
        { lineCode: "HNS", Brand: "HANNSPREE REFURB" },
        { lineCode: "HOB", Brand: "HOBART" },
        { lineCode: "HOL", Brand: "HOLMAN" },
        { lineCode: "HOM", Brand: "Homelite" },
        { lineCode: "HON", Brand: "HONDA" },
        { lineCode: "HOO", Brand: "HOOVER" },
        { lineCode: "HOP", Brand: "AYP CRAFTSMAN" },
        { lineCode: "HOR", Brand: "HORTON VALVES" },
        { lineCode: "HOS", Brand: "HOSPIRA" },
        { lineCode: "HOT", Brand: "GE" },
        { lineCode: "HPA", Brand: "HP AFTERMARKET" },
        { lineCode: "HPC", Brand: "HP CANON OEM" },
        { lineCode: "HPR", Brand: "HP REFURBISHED" },
        { lineCode: "HPT", Brand: "METABO HPT" },
        { lineCode: "HRD", Brand: "HEALTH RIDER" },
        { lineCode: "HSL", Brand: "HAIER LITERATURE" },
        { lineCode: "HSR", Brand: "HEAT STREAM" },
        { lineCode: "HTC", Brand: "HTC CELLPHONES" },
        { lineCode: "HTG", Brand: "HUNTINGTON GRILL" },
        { lineCode: "HTK", Brand: "HITEKER" },
        { lineCode: "HUG", Brand: "HUGHES" },
        { lineCode: "HUN", Brand: "HUNTER" },
        { lineCode: "HUS", Brand: "Husqvarna" },
        { lineCode: "HWL", Brand: "HONEYWELL" },
        { lineCode: "HWN", Brand: "HEAT WAGON" },
        { lineCode: "HYD", Brand: "HYDROTECH" },
        { lineCode: "HYG", Brand: "HYDRO GEAR" },
        { lineCode: "HZN", Brand: "HORIZON FITNESS" },
        { lineCode: "IBM", Brand: "IBM" },
        { lineCode: "IBX", Brand: "IBM REFURB" },
        { lineCode: "ICE", Brand: "" },
        { lineCode: "ICP", Brand: "INT. CONFORT PARTS" },
        { lineCode: "ICR", Brand: "" },
        { lineCode: "IFT", Brand: "Infotainment" },
        { lineCode: "ILO", Brand: "ILO" },
        { lineCode: "ILX", Brand: "INNOLUX" },
        { lineCode: "IMP", Brand: "IMPORT" },
        { lineCode: "IMT", Brand: "COMPUTER PARTS" },
        { lineCode: "IND", Brand: "INDUSTRIAL AIR" },
        { lineCode: "INF", Brand: "INFOCUS" },
        { lineCode: "ING", Brand: "INGERSOLL RAND" },
        { lineCode: "INH", Brand: "Infratech" },
        { lineCode: "INO", Brand: "INOVATE" },
        { lineCode: "INT", Brand: "INTEL" },
        { lineCode: "IPR", Brand: "IMPRESSION" },
        { lineCode: "ISG", Brand: "INSIGNIA" },
        { lineCode: "ISY", Brand: "I-SYMPHONY" },
        { lineCode: "JAC", Brand: "JACQUES EBERT" },
        { lineCode: "JAN", Brand: "JANCY" },
        { lineCode: "JAP", Brand: "JAPANESE SEMIS" },
        { lineCode: "JAS", Brand: "JASON ILLINOIS INC" },
        { lineCode: "JBL", Brand: "JBL" },
        { lineCode: "JBR", Brand: "0" },
        { lineCode: "TTI", Brand: "Ryobi Elect. Tools" },
        { lineCode: "JCN", Brand: "JACKSON" },
        { lineCode: "JEN", Brand: "JENN-AIR" },
        { lineCode: "JET", Brand: "JET" },
        { lineCode: "JIG", Brand: "REPAIR JIG" },
        { lineCode: "JNY", Brand: "JENNY" },
        { lineCode: "JOG", Brand: "JOHN GUEST" },
        { lineCode: "JON", Brand: "JONSERED" },
        { lineCode: "JVA", Brand: "JVC/AMTRAN" },
        { lineCode: "JVC", Brand: "JVC" },
        { lineCode: "JWH", Brand: "J.W. HARRIS" },
        { lineCode: "JZI", Brand: "JACUZZI" },
        { lineCode: "KAB", Brand: "KABA ILCO" },
        { lineCode: "KAD", Brand: "KITCHEN AID" },
        { lineCode: "KAR", Brand: "KARCHER" },
        { lineCode: "KAS", Brand: "GENERIC COMPUTER" },
        { lineCode: "KAT", Brand: "KOVA" },
        { lineCode: "KAW", Brand: "Kawasaki" },
        { lineCode: "KDS", Brand: "KDS MONITORS" },
        { lineCode: "KDX", Brand: "KDSUSA INC REFURB" },
        { lineCode: "KEF", Brand: "KEF AUDIO" },
        { lineCode: "KEL", Brand: "KELON" },
        { lineCode: "KEN", Brand: "KENWOOD" },
        { lineCode: "KEW", Brand: "KENWOOD" },
        { lineCode: "KIR", Brand: "KIRBY" },
        { lineCode: "KIT", Brand: "APPLIANCE PARTS" },
        { lineCode: "KMR", Brand: "KENMORE-DAEWOO" },
        { lineCode: "KNA", Brand: "KNAACK" },
        { lineCode: "KNL", Brand: "KENDALL" },
        { lineCode: "KOB", Brand: "KOBALT" },
        { lineCode: "KOD", Brand: "KODAK" },
        { lineCode: "KOH", Brand: "KOHLER" },
        { lineCode: "KON", Brand: "KONKA" },
        { lineCode: "KOR", Brand: "KODAK REFURB" },
        { lineCode: "KRU", Brand: "KRUPS" },
        { lineCode: "KWD", Brand: "SCOPES & POWER SUPP." },
        { lineCode: "KYO", Brand: "KYOCERA MITA" },
        { lineCode: "LAN", Brand: "LANG" },
        { lineCode: "LAS", Brand: "LASKO" },
        { lineCode: "LAW", Brand: "LAWN BOY" },
        { lineCode: "LEH", Brand: "LENOVO RECERTIFIED" },
        { lineCode: "LEN", Brand: "LENOVO" },
        { lineCode: "LEX", Brand: "LEXMARK" },
        { lineCode: "LGE", Brand: "LG WIRELESS" },
        { lineCode: "ZEN", Brand: "LG" },
        { lineCode: "LIE", Brand: "LIEBHERR" },
        { lineCode: "LIF", Brand: "LIFTMASTER" },
        { lineCode: "LIN", Brand: "LINKSYS" },
        { lineCode: "LIT", Brand: "LITTLEFUSE" },
        { lineCode: "LMB", Brand: "LMB HEEGER" },
        { lineCode: "LMP", Brand: "LAMP ONLY" },
        { lineCode: "LNX", Brand: "LENNOX" },
        { lineCode: "LOK", Brand: "LOKRING APPLIANCE" },
        { lineCode: "LOR", Brand: "OBSERVATION STSYEMS" },
        { lineCode: "LOW", Brand: "LOWELL" },
        { lineCode: "LPS", Brand: "LPS" },
        { lineCode: "LPU", Brand: "GENERIC" },
        { lineCode: "LTW", Brand: "LITTLE WONDER" },
        { lineCode: "LUX", Brand: "LUXOR" },
        { lineCode: "LVR", Brand: "LIQUID VIDEO REFURB" },
        { lineCode: "LXA", Brand: "0" },
        { lineCode: "LXR", Brand: "LEXMARK REFURB" },
        { lineCode: "LYN", Brand: "LYNX" },
        { lineCode: "MAA", Brand: "MOTORS & ARMATURES" },
        { lineCode: "MAC", Brand: "MAGIC CHEF" },
        { lineCode: "MAE", Brand: "MA-LINE" },
        { lineCode: "MAG", Brand: "MAGNAVOX" },
        { lineCode: "MAJ", Brand: "MAJESTIC" },
        { lineCode: "MAK", Brand: "MAKITA" },
        { lineCode: "MAL", Brand: "MALLORY" },
        { lineCode: "MAR", Brand: "MARANTZ" },
        { lineCode: "MAS", Brand: "MASTER" },
        { lineCode: "MAT", Brand: "MATRIX FITNESS" },
        { lineCode: "MAX", Brand: "MAXELL" },
        { lineCode: "MAY", Brand: "MAYTAG/AMANA" },
        { lineCode: "MCC", Brand: "McCULLOCH" },
        { lineCode: "MCM", Brand: "MCM" },
        { lineCode: "MCS", Brand: "MICROSOFT" },
        { lineCode: "MDM", Brand: "MEDEX" },
        { lineCode: "MET", Brand: "METABO HPT - HITACHI" },
        { lineCode: "MGT", Brand: "MARGARITAVILLE" },
        { lineCode: "MIA", Brand: "MIAMI PARTS" },
        { lineCode: "MID", Brand: "MIDEA" },
        { lineCode: "MIE", Brand: "MIELE" },
        { lineCode: "MIL", Brand: "MILWAUKEE" },
        { lineCode: "MIM", Brand: "MI-T-M" },
        { lineCode: "MIN", Brand: "KONICA MINOLTA" },
        { lineCode: "MIR", Brand: "MIRACLE REMOTE" },
        { lineCode: "MIS", Brand: "MASS INTEGRATED" },
        { lineCode: "MIT", Brand: "MITSUBISHI" },
        { lineCode: "MKA", Brand: "MINN KOTA" },
        { lineCode: "MKD", Brand: "MK DIAMOND" },
        { lineCode: "MKF", Brand: "MARKET FORGE" },
        { lineCode: "MLM", Brand: "MIDLAND METAL" },
        { lineCode: "MMM", Brand: "3M FILTRETE PRODUCTS" },
        { lineCode: "MNN", Brand: "Monessen" },
        { lineCode: "MOE", Brand: "MOEN" },
        { lineCode: "MOT", Brand: "MOTOROLA" },
        { lineCode: "MRC", Brand: "MRCOOL" },
        { lineCode: "MRF", Brand: "MR COFFEE" },
        { lineCode: "MRH", Brand: "MR HEATER" },
        { lineCode: "MRO", Brand: "MIRRO" },
        { lineCode: "MRQ", Brand: "MARQUIS" },
        { lineCode: "MRX", Brand: "MOTOROLA REFURB" },
        { lineCode: "MSC", Brand: "PANASONIC" },
        { lineCode: "MSI", Brand: "MSI COMPUTER" },
        { lineCode: "MSL", Brand: "MATSUSHITA" },
        { lineCode: "MSR", Brand: "PANASONIC REFURB" },
        { lineCode: "MST", Brand: "MST" },
        { lineCode: "MTA", Brand: "MOTOROLA AFTER MKT" },
        { lineCode: "MTD", Brand: "TROY BILT YARDMAN" },
        { lineCode: "MTR", Brand: "MITSUBISHI REFURB" },
        { lineCode: "MTX", Brand: "MTX SPEAKERS" },
        { lineCode: "MUR", Brand: "MURATEC" },
        { lineCode: "MXP", Brand: "MAX PROFESSIONAL" },
        { lineCode: "MXX", Brand: "MAX" },
        { lineCode: "NAD", Brand: "NADY" },
        { lineCode: "NAL", Brand: "PHILIPS MANUALS" },
        { lineCode: "NAP", Brand: "PHILIPS" },
        { lineCode: "NCR", Brand: "NORELCO FINISHED" },
        { lineCode: "NDA", Brand: "APPL. INSTALL KITS" },
        { lineCode: "NDT", Brand: "NordicTrack" },
        { lineCode: "NEC", Brand: "NEC" },
        { lineCode: "NEO", Brand: "OSRAM NEOLUX" },
        { lineCode: "NES", Brand: "NESPRESSO" },
        { lineCode: "NEX", Brand: "NEXTBOOK USA" },
        { lineCode: "NGK", Brand: "SPARK PLUGS" },
        { lineCode: "NGL", Brand: "NEXGRILL" },
        { lineCode: "NKN", Brand: "NIKON" },
        { lineCode: "NOR", Brand: "NORELCO" },
        { lineCode: "NOV", Brand: "NOVATEK" },
        { lineCode: "NPL", Brand: "NAPOLEON" },
        { lineCode: "NPS", Brand: "ANDERIC" },
        { lineCode: "NSA", Brand: "NSA RECOVERY" },
        { lineCode: "NTE", Brand: "NTE ELECTRONICS" },
        { lineCode: "NTK", Brand: "NORTEK" },
        { lineCode: "NUK", Brand: "NUKOTE" },
        { lineCode: "NUM", Brand: "NUMEREX" },
        { lineCode: "NUO", Brand: "NUOVA SIMONELLI" },
        { lineCode: "NUT", Brand: "NUTONE" },
        { lineCode: "NWD", Brand: "GREEN CHOICE" },
        { lineCode: "NWS", Brand: "NEW WAVE SALES" },
        { lineCode: "NXX", Brand: "NEXXTECH" },
        { lineCode: "ODY", Brand: "ODYSSEY" },
        { lineCode: "OFC", Brand: "OFFICE SUPPLIES" },
        { lineCode: "OKI", Brand: "OKIDATA" },
        { lineCode: "OKR", Brand: "OKIDATA REFURB" },
        { lineCode: "OLE", Brand: "OLEVIA" },
        { lineCode: "OLY", Brand: "OLYMPUS" },
        { lineCode: "ONK", Brand: "ONKYO" },
        { lineCode: "OPL", Brand: "OPAL ICEMAKERS" },
        { lineCode: "OPT", Brand: "OPTOMA" },
        { lineCode: "ORB", Brand: "ORAL-B" },
        { lineCode: "ORE", Brand: "ORECK" },
        { lineCode: "ORG", Brand: "Oregon" },
        { lineCode: "ORI", Brand: "ORION" },
        { lineCode: "OSR", Brand: "OSRAM" },
        { lineCode: "OST", Brand: "Oster" },
        { lineCode: "PAC", Brand: "TOOLS" },
        { lineCode: "PAF", Brand: "PHILIPS PRODUCT" },
        { lineCode: "PAK", Brand: "PACKARD INC" },
        { lineCode: "PAR", Brand: "MEMORY PRODUCTS" },
        { lineCode: "PAT", Brand: "PATIO COMFORT" },
        { lineCode: "PBS", Brand: "PHILIPS HOSPITALITY" },
        { lineCode: "PCI", Brand: "PREMIUM COMPATIBLES" },
        { lineCode: "PCL", Brand: "PHILIPS LIFE STYLE" },
        { lineCode: "PCN", Brand: "PROSCAN" },
        { lineCode: "PCO", Brand: "MATV/CATV ACC" },
        { lineCode: "PDL", Brand: "PHILIPS DIRECT LIFE" },
        { lineCode: "PDT", Brand: "PANDUIT" },
        { lineCode: "PEG", Brand: "PEG PEREGO" },
        { lineCode: "PEN", Brand: "Penn" },
        { lineCode: "PER", Brand: "PERLICK" },
        { lineCode: "PET", Brand: "POLAROID" },
        { lineCode: "PFH", Brand: "PHILIPS HOSP. CANADA" },
        { lineCode: "PFL", Brand: "PFLUEGER" },
        { lineCode: "PGC", Brand: "PHILIPS GARMENT CARE" },
        { lineCode: "PGS", Brand: "PGS GRILL" },
        { lineCode: "PHC", Brand: "PHILIPS HEALTHY COOK" },
        { lineCode: "PHI", Brand: "PHILMORE" },
        { lineCode: "PHL", Brand: "PHILIPS LIGHTING" },
        { lineCode: "PHS", Brand: "Philips Health Solut" },
        { lineCode: "PHX", Brand: "PHOENIX LAMP" },
        { lineCode: "PIN", Brand: "PINNACLE SALES" },
        { lineCode: "PIO", Brand: "PIONEER" },
        { lineCode: "PIT", Brand: "PITCO" },
        { lineCode: "PKG", Brand: "PACKAGING" },
        { lineCode: "PLA", Brand: "PLASMAIR" },
        { lineCode: "PLC", Brand: "PERLICK" },
        { lineCode: "PLK", Brand: "POLK" },
        { lineCode: "PLT", Brand: "POLTI" },
        { lineCode: "PMT", Brand: "POWERMATIC" },
        { lineCode: "PNF", Brand: "PHILIPS" },
        { lineCode: "POR", Brand: "POLTI REFURBISHED" },
        { lineCode: "POU", Brand: "POULAN" },
        { lineCode: "POW", Brand: "POWERSONIC" },
        { lineCode: "PPA", Brand: "PEERLESS RANGE CO." },
        { lineCode: "PPH", Brand: "Philips Purifiers" },
        { lineCode: "PPP", Brand: "PARTPOINT PARTS" },
        { lineCode: "PRB", Brand: "BELT AND VCR ACC." },
        { lineCode: "PRE", Brand: "PRESTO" },
        { lineCode: "PRF", Brand: "PROFORM" },
        { lineCode: "PRP", Brand: "PRO TEMP" },
        { lineCode: "PRT", Brand: "PROTECTIVE COATING" },
        { lineCode: "PRV", Brand: "PROVIEW" },
        { lineCode: "PSX", Brand: "PROCTOR SILEX" },
        { lineCode: "PTA", Brand: "PETRA" },
        { lineCode: "PTC", Brand: "Porter Cable" },
        { lineCode: "PTR", Brand: "PENTAIR" },
        { lineCode: "PTS", Brand: "PTS MODULES" },
        { lineCode: "PWM", Brand: "POWERMATE" },
        { lineCode: "PWS", Brand: "POWER WHEELS" },
        { lineCode: "PWW", Brand: "PRIMA WORLDWIDE" },
        { lineCode: "QJO", Brand: "CELL PHONE" },
        { lineCode: "QST", Brand: "QST" },
        { lineCode: "QTM", Brand: "QUANTUM VIEW" },
        { lineCode: "QUA", Brand: "QUAM" },
        { lineCode: "QUE", Brand: "COMPUTER SOFTWARE" },
        { lineCode: "QVS", Brand: "COMPUTER CABLES" },
        { lineCode: "RAI", Brand: "RAIN BIRD" },
        { lineCode: "RAN", Brand: "RANDELL" },
        { lineCode: "RAW", Brand: "CHEMICALS" },
        { lineCode: "RAZ", Brand: "RAZOR" },
        { lineCode: "RCA", Brand: "RCA" },
        { lineCode: "RCL", Brand: "TCE TECHNICAL" },
        { lineCode: "RCX", Brand: "RICOH REFURBISHED" },
        { lineCode: "REB", Brand: "GREEN CHOICE" },
        { lineCode: "REC", Brand: "RECTORSEAL" },
        { lineCode: "RED", Brand: "REDMAX" },
        { lineCode: "REM", Brand: "REMINGTON" },
        { lineCode: "REP", Brand: "REPLACEMENT TRANSIST" },
        { lineCode: "RHE", Brand: "Rheem" },
        { lineCode: "RIC", Brand: "RICOH" },
        { lineCode: "RID", Brand: "RIDGID" },
        { lineCode: "RIE", Brand: "RITCHIE ENGINEERING" },
        { lineCode: "RIT", Brand: "RITE OFF" },
        { lineCode: "ROB", Brand: "ROBERTSHAW" },
        { lineCode: "ROC", Brand: "ROCKWELL" },
        { lineCode: "ROD", Brand: "ROBINAIR DIVISON" },
        { lineCode: "ROL", Brand: "ROLAIR" },
        { lineCode: "ROT", Brand: "ROTARY (AFTERMARKET)" },
        { lineCode: "ROW", Brand: "ROWENTA" },
        { lineCode: "ROY", Brand: "ROYAL" },
        { lineCode: "RTL", Brand: "GREEN CHOICE" },
        { lineCode: "RTV", Brand: "OPEN BOX PRODUCT" },
        { lineCode: "RTZ", Brand: "ROTOZIP" },
        { lineCode: "RUN", Brand: "RUNCO" },
        { lineCode: "RUU", Brand: "RUUD" },
        { lineCode: "SAE", Brand: "SAECO" },
        { lineCode: "SAM", Brand: "CELL PHONE PARTS" },
        { lineCode: "SAN", Brand: "SANITAIRE" },
        { lineCode: "SAT", Brand: "STEVENS APPLIANCE TR" },
        { lineCode: "SBD", Brand: "SOUTHBEND" },
        { lineCode: "SCE", Brand: "SCEPTRE" },
        { lineCode: "SCO", Brand: "SCOTSMAN" },
        { lineCode: "SCR", Brand: "SONICARE" },
        { lineCode: "SEI", Brand: "SEIKI" },
        { lineCode: "SEN", Brand: "SENSEO" },
        { lineCode: "SEP", Brand: "SENSIBLE PRODUCTS" },
        { lineCode: "SFS", Brand: "SANYO" },
        { lineCode: "SGG", Brand: "SMEG" },
        { lineCode: "SGM", Brand: "SIGMAC USA" },
        { lineCode: "SGO", Brand: "SUNGLO" },
        { lineCode: "SHA", Brand: "SHARP" },
        { lineCode: "SHI", Brand: "SHINDAIWA" },
        { lineCode: "SHK", Brand: "SHAKESPEARE" },
        { lineCode: "SHM", Brand: "SHIMANO" },
        { lineCode: "SHO", Brand: "SHOPVAC" },
        { lineCode: "SHT", Brand: "SUNHEAT" },
        { lineCode: "SIL", Brand: "SILHOUETTE" },
        { lineCode: "SIM", Brand: "SIMPLICITY" },
        { lineCode: "SJP", Brand: "GREEN CHOICE" },
        { lineCode: "SKI", Brand: "SKIL" },
        { lineCode: "SKU", Brand: "SKUTTLE" },
        { lineCode: "SLD", Brand: "SOUTHLAND" },
        { lineCode: "SLY", Brand: "STANLEY" },
        { lineCode: "SMC", Brand: "SANYO MANUFACTURING" },
        { lineCode: "SMD", Brand: "SMUDGETIP" },
        { lineCode: "SME", Brand: "SIMER" },
        { lineCode: "SMG", Brand: "SAMSUNG" },
        { lineCode: "SMR", Brand: "SAMSUNG REFURB" },
        { lineCode: "SMT", Brand: "SMART TECHNOLOGIES" },
        { lineCode: "SNA", Brand: "SNAPPER" },
        { lineCode: "SNC", Brand: "SENCO" },
        { lineCode: "SNS", Brand: "SONOS" },
        { lineCode: "SNY", Brand: "SONY ACCESSORIES" },
        { lineCode: "SOH", Brand: "GREEN CHOICE" },
        { lineCode: "SON", Brand: "SONY" },
        { lineCode: "SOU", Brand: "SOUNDLIER" },
        { lineCode: "SPA", Brand: "BAYSTATE POOL" },
        { lineCode: "SPC", Brand: "COMMERCIAL WATER DIS" },
        { lineCode: "SPE", Brand: "SPECTRUM" },
        { lineCode: "SPK", Brand: "SUNPAK" },
        { lineCode: "SPQ", Brand: "SPEED QUEEN" },
        { lineCode: "SPR", Brand: "SPECTRUM REFURBISHED" },
        { lineCode: "SPT", Brand: "SPRAYTECH" },
        { lineCode: "SRC", Brand: "MISC" },
        { lineCode: "SRK", Brand: "SHARK" },
        { lineCode: "SRN", Brand: "Subaru / Robin" },
        { lineCode: "SSL", Brand: "SONY SERVICE LIT." },
        { lineCode: "SST", Brand: "SUN-STREAM" },
        { lineCode: "STA", Brand: "STAR" },
        { lineCode: "STC", Brand: "STANCO" },
        { lineCode: "STE", Brand: "STERLING" },
        { lineCode: "STL", Brand: "STARLOGIC REFURBISH" },
        { lineCode: "STM", Brand: "SYSTEMAX" },
        { lineCode: "STN", Brand: "XFMRS & SOLENOIDS" },
        { lineCode: "STR", Brand: "Star Trac" },
        { lineCode: "SUB", Brand: "SUB ZERO" },
        { lineCode: "SUI", Brand: "SUBARU INDUSTRIAL" },
        { lineCode: "SUM", Brand: "SUMMIT BRANDS" },
        { lineCode: "SUN", Brand: "SUNBEAM" },
        { lineCode: "SUP", Brand: "SUPPLIES" },
        { lineCode: "SUR", Brand: "Sure Flame" },
        { lineCode: "SVA", Brand: "SVA" },
        { lineCode: "SWI", Brand: "SWITCHCRAFT" },
        { lineCode: "SYL", Brand: "SYLVANIA" },
        { lineCode: "SYR", Brand: "SOYO REFURBISHED" },
        { lineCode: "T-F", Brand: "T-FAL" },
        { lineCode: "TAN", Brand: "TANAKA" },
        { lineCode: "TBA", Brand: "TOSHIBA" },
        { lineCode: "TCL", Brand: "TCL" },
        { lineCode: "TEC", Brand: "TECH SPRAY" },
        { lineCode: "TEP", Brand: "TECUMSEH PEERLESS" },
        { lineCode: "TGC", Brand: "THE GOOD CLEAN" },
        { lineCode: "THO", Brand: "THOR" },
        { lineCode: "THT", Brand: "THERMOFLUID TECH" },
        { lineCode: "TIT", Brand: "TITAN" },
        { lineCode: "TKK", Brand: "FRS RADIO" },
        { lineCode: "TKX", Brand: "TEKTRONIX" },
        { lineCode: "TMP", Brand: "TEMPUR-PEDIC" },
        { lineCode: "TMT", Brand: "TOM TOM" },
        { lineCode: "TNT", Brand: "TNT" },
        { lineCode: "TOR", Brand: "TORO" },
        { lineCode: "TOS", Brand: "TOSHIBA COMPUTER" },
        { lineCode: "TPV", Brand: "TPV TECHNOLOGY" },
        { lineCode: "TRA", Brand: "TRADEPRO" },
        { lineCode: "TRI", Brand: "TRIPP-LITE" },
        { lineCode: "TRN", Brand: "TRANE" },
        { lineCode: "TRU", Brand: "1" },
        { lineCode: "TSH", Brand: "TECUMSEH" },
        { lineCode: "TSM", Brand: "TRI-STATE MODULE" },
        { lineCode: "TST", Brand: "TEST PARTS" },
        { lineCode: "TTI", Brand: "RYOBI" },
        { lineCode: "TTW", Brand: "TITAN TANKLESS WATER" },
        { lineCode: "TUT", Brand: "TUTCO HEATING SOLUTI" },
        { lineCode: "TWI", Brand: "TWIN EAGLES" },
        { lineCode: "ULE", Brand: "UNIVERSAL ENT" },
        { lineCode: "ULN", Brand: "U-LINE" },
        { lineCode: "UNI", Brand: "UNIWELD" },
        { lineCode: "USD", Brand: "USD PRODUCTS" },
        { lineCode: "USP", Brand: "RECHARGEABLE BATTERY" },
        { lineCode: "USS", Brand: "US STOVE COMPANY" },
        { lineCode: "VAI", Brand: "VAIN STHLM" },
        { lineCode: "VAN", Brand: "VANCO" },
        { lineCode: "VAP", Brand: "VAPCO PRODUCTS" },
        { lineCode: "VBI", Brand: "MISC." },
        { lineCode: "VEL", Brand: "TEST EQUIPMENT" },
        { lineCode: "VEN", Brand: "Vent-A-Hood" },
        { lineCode: "VER", Brand: "VERMONT" },
        { lineCode: "VGA", Brand: "VIDEO GAMING ADV" },
        { lineCode: "VIK", Brand: "VIKING APPLIANCES" },
        { lineCode: "VIO", Brand: "VIORE" },
        { lineCode: "VIR", Brand: "VIRGINIA AIR" },
        { lineCode: "VIS", Brand: "VISION FITNESS" },
        { lineCode: "VIV", Brand: "VIVITEK" },
        { lineCode: "VIZ", Brand: "VIZIO" },
        { lineCode: "VMP", Brand: "VIDEO MOUNT PRODUCTS" },
        { lineCode: "VRG", Brand: "VERGE" },
        { lineCode: "VSR", Brand: "V7E ELECT. REFURBISH" },
        { lineCode: "VUL", Brand: "VULCAN HART" },
        { lineCode: "VWS", Brand: "VIEWSONIC REFURB" },
        { lineCode: "VZP", Brand: "VIZPARTS" },
        { lineCode: "WAG", Brand: "WAGNER" },
        { lineCode: "WAL", Brand: "WALBRO" },
        { lineCode: "WAR", Brand: "WARING" },
        { lineCode: "WBR", Brand: "WEBER" },
        { lineCode: "WDE", Brand: "WESTINGHOUSE" },
        { lineCode: "WDR", Brand: "WESTERN DIG. REFURB" },
        { lineCode: "WEA", Brand: "WEATHER GUARD" },
        { lineCode: "WEB", Brand: "POWER CORDS" },
        { lineCode: "WEE", Brand: "WEED EATER" },
        { lineCode: "WEL", Brand: "WELLS" },
        { lineCode: "WES", Brand: "WEST PENN" },
        { lineCode: "WFS", Brand: "WOOD FINISHING" },
        { lineCode: "WHI", Brand: "Whirlpool" },
        { lineCode: "WHR", Brand: "WHITE-RODGERS" },
        { lineCode: "WII", Brand: "WII NINTENDO" },
        { lineCode: "WIK", Brand: "WIKO LAMPS" },
        { lineCode: "WIL", Brand: "WILTON" },
        { lineCode: "WIN", Brand: "WINEGARD" },
        { lineCode: "WIS", Brand: "WISTRON" },
        { lineCode: "WLK", Brand: "WALKER & SONS" },
        { lineCode: "WLT", Brand: "WELTON" },
        { lineCode: "WMN", Brand: "WHITE MOUNTAIN" },
        { lineCode: "WOL", Brand: "WOLF APPLIANCE" },
        { lineCode: "WOR", Brand: "WORX" },
        { lineCode: "WSL", Brand: "WESLO" },
        { lineCode: "WYS", Brand: "WYSE" },
        { lineCode: "XAN", Brand: "XANTUS PRODUCTS" },
        { lineCode: "XER", Brand: "XEROX" },
        { lineCode: "XTG", Brand: "X2GEN REFURBISHED" },
        { lineCode: "YAM", Brand: "YAMAHA" },
        { lineCode: "YAR", Brand: "YARD MAN" },
        { lineCode: "YCX", Brand: "YC" },
        { lineCode: "YEA", Brand: "YEATS DOLLY" },
        { lineCode: "YOR", Brand: "YORK" },
        { lineCode: "ZAM", Brand: "ZAMA" },
        { lineCode: "ZEB", Brand: "ZEBRA" },
        { lineCode: "ZEN", Brand: "LG" },
        { lineCode: "ZER", Brand: "LG ELECTRONICS REFUR" },
        { lineCode: "ZOD", Brand: "ZODIAC" },
        { lineCode: "ZTS", Brand: "ZT SYSTEMS" },
      ];

      // $(".suggestion-list").html("")
      var NewHtml = '';
      const $slider = $("#suggestion-list");  
        
      setTimeout(function() {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }
        $("#suggestion-list").html("");
        
        product_search?.nodes?.forEach((product) => {
        var tags = product.tags;
        const title = product.title;
        let images = product.images;
        const vendor = product.vendor;
        const handle = product.handle;
        const variants = product.variants;
        var brandName = product.vendor;
        const formatString = (str) =>
          str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        const matchingBrand = Brand_json.find(
          (item) => formatString(item.Brand) === formatString(brandName)
        );
        // console.log("matchingBrand",matchingBrand.lineCode)

          let lineCodeMat = '';
          if(matchingBrand){
            lineCodeMat = matchingBrand.lineCode ;
          }else{
            lineCodeMat = '';
          }

        let amount = variants ? variants.nodes[0].price.amount : "";
          // console.log("amount",amount)

        let finAmou = '';
          if(amount == '0.0'){
            finAmou = '';
          }else{
            finAmou = `$${amount}`;
          }
          // console.log("finAmou>>",finAmou)

         
          
          
        const sku = variants ? variants.nodes[0].sku : "";
        // console.log("SKU", sku);

        const variantsid = variants.nodes[0].id;
        var variIdFilter = variantsid.split("/").pop();

         let btnAddNdCont = '';

        if(amount == '0.0'){
          btnAddNdCont = `<a class="ViewModel" href="products/${handle}" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link" viewBox="0 0 16 16">
  <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"></path>
  <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z"></path>
</svg></a>`;
        }else{
          btnAddNdCont = `<button data-pid='${variIdFilter}' class='js_add_to_cart_button add_to_cart_SF linkclass'>
          <div class='cart_icon_img'><img src='https://cdn.shopify.com/s/files/1/0700/0293/3937/files/cardbag.svg?v=1745224987'></div><span class='text'></span></button>`;
        }
          // console.log("images",images)
          
        var imagesrc = "";
        if (images && images.nodes.length > 0) {
          imagesrc = images.nodes[0]?.originalSrc;
          // console.log("found imagesrc ", imagesrc)
        } else {
          imagesrc =
            "https://encompass-11307.kxcdn.com/imageDisplay?mfgCode=" +
            lineCodeMat +
            "&type=b&size=s";
        }
        // console.log("Image source", imagesrc);
        // console.log("Title", title);
        // console.log("Tags", tags);

        var truncatedTitle =
          title.length > 50 ? title.substring(0, 50) + "..." : title;
$('.loader_filter').hide();
        let brandhtml =
          "<div class='filterslide dfdfd app productDatalist NewOneForBrand rrr'><a class='brnd_arch' href='products/" +
          handle +
          "'><div class='sel_brnd_img dfgff'><img class='brnd_img' src=" +
          imagesrc +
          "></div></a><div class='search-filtersel'><a class='brnd_arch' href='products/" +
          handle +
          "'><p class='brnd_title'>" +
          truncatedTitle +
          "</p></a><p class='background-eye quickViewPopup' data-pid='" + product.id + "' data-handle='" + product.handle + "'>" +
          "<span class='loader-quick-view'></span>"+
          "<img src='https://cdn.shopify.com/s/files/1/0700/0293/3937/files/Group_1000002717_1.svg?v=1745487338' alt='Icon 1'>" +
          "</p><a class='brnd_arch brnd-price' href='products/" +
          handle +
          "'><p class='brnd_sku' style='display:none;'>" +
          sku +
          "</p><p class='brnd_pro_price'>" +
          finAmou +
          "</p><p class='brnd_vendor'>" +
          vendor +
          "</p></a></div>" +
          btnAddNdCont +
          "</div>";
        // $("#apps").html("<div class='app productDatalist'><a class='brnd_arch' href='products/" + handle + "'><div class='sel_brnd_img dfgff'><img class='brnd_img' src=" + imagesrc + "></div></a><a class='brnd_arch' href='products/" + handle + "'><p class='brnd_title'>" + truncatedTitle + "</p><p class='brnd_sku' style='display:none;'>" + sku + "</p><p class='brnd_pro_price'>$" + amount + "</p><p class='brnd_vendor'>" + vendor + "</p></a><button data-pid='"+ variIdFilter +"' class='js_add_to_cart_button add_to_cart_SF linkclass'><div class='cart_icon_img'><img src='https://cdn.shopify.com/s/files/1/0638/4887/4142/files/Group_4.png?v=1719407493'></div><span class='text'>Add to Cart</span></button></div>");
        // $("#apps").append(brandhtml);

        $('.loader_filter').css('display','none')
        $("#suggestion-list").append(brandhtml);
  
      });
       
      var slidecount = 5;    
      if(window.innerWidth <= 767){
         slidecount = 2;
      }
      
      if (product_search.nodes.length > slidecount) { 
        $slider.slick({
          lazyLoad: "ondemand",
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          speed: 700,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 4, 
                slidesToScroll: 1,
               
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
               
              }
            },
             {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 5,
               
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll:1
              }
            }
          ]
        });
      }

}, 2000);
     
 
     
       
      }
      
    })
    .catch((error) => {
      console.error("Error:", error);
    });


}
  

$(document).ready(function () {
  $("section.search_with_bg .brand-item").on("click", function () {
    // Remove 'zoomed' class from all articles
    $("section.search_with_bg .brand-item").removeClass("zoomed");

    // Add 'zoomed' class to the clicked article
    $(this).addClass("zoomed");
  });
});

}  // end if condition of template


// Scroll tracking - Add this to your theme JavaScript
(function() {
  let scrollTracked = {
    25: false,
    50: false,
    75: false,
    90: false
  };
  
  function calculateScrollPercentage() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    const scrollableHeight = documentHeight - windowHeight;
    const scrollPercentage = scrollableHeight > 0 ? Math.round((scrollTop / scrollableHeight) * 100) : 0;
    
    return Math.min(scrollPercentage, 100);
  }
  
  function handleScrollTracking() {
    const scrollPercentage = calculateScrollPercentage();
    const thresholds = [25, 50, 75, 90];
    
    thresholds.forEach(threshold => {
      if (scrollPercentage >= threshold && !scrollTracked[threshold]) {
        scrollTracked[threshold] = true;
        
        // Publish to Shopify analytics
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish('on_page_scroll', {
            customData: {
              scroll_percent: threshold,
              page_path: window.location.pathname,
              page_location: window.location.href,
              page_title: document.title
            }
          });
          
          console.log(`Scroll ${threshold}% event published`);
        }
      }
    });
  }
  
  let scrollTimeout;
  function throttledScrollHandler() {
    if (scrollTimeout) return;
    scrollTimeout = setTimeout(() => {
      handleScrollTracking();
      scrollTimeout = null;
    }, 250);
  }
  
  window.addEventListener('scroll', throttledScrollHandler, { passive: true });
  
  // Reset on page navigation (for SPAs)
  document.addEventListener('DOMContentLoaded', () => {
    scrollTracked = { 25: false, 50: false, 75: false, 90: false };
  });
  
  console.log('Theme scroll tracking initialized');
})();

